import type { HomePageQueryFactory } from "./types";

const LISTS_QUERY_KEY = "home:lists";
const SAVED_SEARCHES_QUERY_KEY = "home:savedSearches";

export const homePageQueryKeys: HomePageQueryFactory = {
    lists(): readonly string[] {
        return [LISTS_QUERY_KEY];
    },

    listAssetsCount(listId: string): readonly string[] {
        return [...homePageQueryKeys.lists(), "count", listId];
    },

    savedSearches(): readonly string[] {
        return [SAVED_SEARCHES_QUERY_KEY];
    },

    savedSearchesCounts(searchId: string): readonly string[] {
        return [...homePageQueryKeys.savedSearches(), "count", searchId];
    },
};
